import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of } from "rxjs";
import { environment } from "../../../environments/environment";
import {PageConfiguration, PageConfigurationResponse} from '../types/page-configuration.types';
import {EntityResponse} from '../types/types';

@Injectable({
    providedIn: "root",
})
export class PageConfigurationService {
    private _httpClient = inject(HttpClient);

    private _pageConfiguration = new BehaviorSubject<PageConfigurationResponse | null>(null);

    get pageConfiguration$(): Observable<PageConfigurationResponse | null> {
        return this._pageConfiguration.asObservable();
    }

    getConfiguration(shortLink: string): Observable<PageConfigurationResponse>
    {
        return this._httpClient
            .get<EntityResponse<PageConfiguration>>(`${environment.apiSettings.baseUrl}/${environment.apiSettings.version}/page-configurations/${shortLink}`)
            .pipe(
                map((response: any) => {
                    // Transform successful response
                    const pageConfiguration: PageConfiguration = response.data;
                    const pageConfigurationResponse: PageConfigurationResponse = {
                        success: true,
                        data: pageConfiguration
                    };

                    this._pageConfiguration.next(pageConfigurationResponse);

                    return pageConfigurationResponse;
                }),
                catchError((error: HttpErrorResponse) => {
                    // Create error response
                    const errorResponse: PageConfigurationResponse = {
                        success: false,
                        errorMessage: error.error?.message || 'Invalid or expired link. Please contact your agent for a new link.'
                    };

                    this._pageConfiguration.next(errorResponse);

                    // Return the error response as an observable
                    return of(errorResponse);
                })
            );
    }
}
